<div class="card mb-2" *transloco="let t">
    <div class="card-header">
      <h3>{{ t('I have some questions') }}</h3>
    </div>
    <div class="card-body">
        <p>{{ t('If you have any questions about OK Alone or thoughts on how we can monitor your remote workforce please contact using one of the methods below:') }}</p>

        <p>
            {{ t('Call') }} : +1-844-900-0478 / +44 131 610 2016 <br />
            {{ t('Email') }}: <a href="mailto: customer.support@ok-alone.com">customer.support&#64;ok-alone.com</a><br />
            {{ t('Chat') }}: {{ t('Use the chat box below') }}
        </p>

    </div>
  </div>